import React from 'react';

import {classNames} from '~/src/utilities/helpers/css';

import css from './Layout.module.scss';

interface LayoutProps {
    children: React.ReactNode;
    isCentered?: boolean;
    contentType?: string;
    className?: string;
}

const Layout = ({children, isCentered = false, contentType = undefined, className}: LayoutProps) => {
    const classes = [classNames(css, 'layout', {isCentered}, {contentType}), className].filter(Boolean).join(' ');

    return (
        <div className={classes}>
            <div className={css.content}>{children}</div>
        </div>
    );
};

export default Layout;
